import { Box, Button, Card, CardContent, Typography } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import PublishIcon from "@material-ui/icons/Publish";
import { httpClient } from "api/httpClient";
import { ProgressIcon } from "components/ProgressIcon";
import React from "react";
import { useTranslate } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

import { labelLogoUrl } from "./useTerminalLabelLogo";

const ACCEPTED_IMAGE_TYPES = ".png,.jpg,.jpeg,.webp";
const PREVIEW_SIZE = 96;

export const TerminalLabelLogo = ({
	terminalId,
	labelLogo,
	isLoading,
	onLabelLogoChange,
	canEdit,
}) => {
	const [isSaving, setIsSaving] = React.useState(false);
	const fileInputRef = React.useRef(null);

	const translate = useTranslate();
	const notifyError = useNotifyError();

	const handleFileSelected = (event) => {
		const file = event.target.files[0];
		event.target.value = "";
		if (!file) return;

		const body = new FormData();
		body.append("file", file);

		setIsSaving(true);
		httpClient(labelLogoUrl(terminalId), { method: "POST", body })
			.then(({ json }) => onLabelLogoChange(json))
			.catch(notifyError)
			.finally(() => setIsSaving(false));
	};

	const handleUploadClick = () => {
		fileInputRef.current.click();
	};

	const handleRemove = () => {
		setIsSaving(true);
		httpClient(labelLogoUrl(terminalId), { method: "DELETE" })
			.then(({ json }) => onLabelLogoChange(json))
			.catch(notifyError)
			.finally(() => setIsSaving(false));
	};

	return (
		<Card>
			<CardContent>
				<Typography variant="h6">
					{translate("resources.terminal.internal-pallet-labels.logo_section")}
				</Typography>
				<Typography variant="body2" color="textSecondary">
					{translate("resources.terminal.internal-pallet-labels.logo_hint")}
				</Typography>
				<Box display="flex" alignItems="center" gridGap={16} marginTop={2}>
					{labelLogo?.src ? (
						<img
							src={labelLogo.src}
							alt={labelLogo.filename}
							style={{ width: PREVIEW_SIZE, height: PREVIEW_SIZE, objectFit: "contain" }}
						/>
					) : (
						!isLoading && (
							<Typography variant="body2">
								{translate("resources.terminal.internal-pallet-labels.logo_missing")}
							</Typography>
						)
					)}
					{canEdit && (
						<>
							<input
								type="file"
								ref={fileInputRef}
								accept={ACCEPTED_IMAGE_TYPES}
								style={{ display: "none" }}
								onChange={handleFileSelected}
							/>
							<Button
								variant="contained"
								color="primary"
								disabled={isLoading || isSaving}
								startIcon={isSaving ? <ProgressIcon /> : <PublishIcon />}
								onClick={handleUploadClick}
							>
								{translate("resources.terminal.internal-pallet-labels.logo_upload")}
							</Button>
							{labelLogo?.filename && (
								<Button
									variant="outlined"
									color="primary"
									disabled={isLoading || isSaving}
									startIcon={<DeleteIcon />}
									onClick={handleRemove}
								>
									{translate("resources.terminal.internal-pallet-labels.logo_remove")}
								</Button>
							)}
						</>
					)}
				</Box>
			</CardContent>
		</Card>
	);
};
